import * as types from './mutation-types';

export const toggleModalEditService = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_EDIT_SERVICE);
};

export const toggleModalCancelNfseId = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_CANCEL_NFSE);
};

export const toggleModalFiscalValidation = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_FISCAL_VALIDATION);
};

export const setModalCancelNfseId = async (context, payload) => {
  const [{ id }] = payload;
  context.commit(types.SET_MODAL_CANCEL_NFSE_ID, id);
};

export const setServiceToEdit = async (context, payload) => {
  context.commit(types.SET_SERVICE_TO_EDIT, payload);
};
